"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceOrientation = exports.DeckMode = exports.SpacedRepModuleConfigType = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../constants");
class SpacedRepModuleConfigType {
    constructor(id, cardMER, dailyStudyCount, deckLength, deckMode, orientationInfo, speedyFactor, nonSpeedyFactor, thirdChanceFactor, speedyAnswerTime, rightAnswerDisplayTime, wrongAnswerDisplayTime, rightMax, rightMin, wrongMax, wrongMin) {
        this.id = id;
        this.cardMER = cardMER;
        this.dailyStudyCount = dailyStudyCount;
        this.deckLength = deckLength;
        this.deckMode = deckMode;
        this.orientationInfo = orientationInfo;
        this.speedyFactor = speedyFactor;
        this.nonSpeedyFactor = nonSpeedyFactor;
        this.thirdChanceFactor = thirdChanceFactor;
        this.speedyAnswerTime = speedyAnswerTime;
        this.rightAnswerDisplayTime = rightAnswerDisplayTime;
        this.wrongAnswerDisplayTime = wrongAnswerDisplayTime;
        this.rightMax = rightMax;
        this.rightMin = rightMin;
        this.wrongMax = wrongMax;
        this.wrongMin = wrongMin;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_SPACED_REP_MODULE_CONFIG;
    }
}
exports.SpacedRepModuleConfigType = SpacedRepModuleConfigType;
var DeckMode;
(function (DeckMode) {
    DeckMode["Wide"] = "GO_WIDE";
    DeckMode["Deep"] = "GO_DEEP";
})(DeckMode = exports.DeckMode || (exports.DeckMode = {}));
var DeviceOrientation;
(function (DeviceOrientation) {
    DeviceOrientation["Vertical"] = "VERTICAL";
    DeviceOrientation["Horizontal"] = "HORIZONTAL";
})(DeviceOrientation = exports.DeviceOrientation || (exports.DeviceOrientation = {}));
